exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".close-container[data-v-69bab114]{max-width:1140px;width:100%;position:relative}.close-container .close-x[data-v-69bab114]{z-index:10000;position:absolute;top:0;right:0}#sfc-main-container[data-v-69bab114]{margin-top:0!important}", ""]);

